import { render, staticRenderFns } from "./DeviceCategoryEditor.vue?vue&type=template&id=32d73c92"
import script from "./DeviceCategoryEditor.vue?vue&type=script&lang=js"
export * from "./DeviceCategoryEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports